import { Base, withBreakpointObserver } from '@studiometa/js-toolkit';
/**
 * Tabs
 */
export default class Tab extends withBreakpointObserver(Base) {
  /**
   * Class config
   * @type {Object}
   */
  static config = {
    name: Tab,
    refs: ['TabBtnClose', 'TabLabel'],
    options: {
      open: Boolean,
      activeBreakpoints: {
        type: String,
        default: 'm l xl xxl',
      },
    },
  };

  /**
   * Mounted
   */
  mounted() {
    if (!sessionStorage.getItem('popin_displayed') && this.$options.open) {
      setTimeout(() => {
        this.$el.classList.add('tabs__open');
      }, 500);
    }
  }

  /**
   * onTabBtnClose
   */
  onTabBtnCloseClick() {
    this.$el.classList.remove('tabs__open');
    this.setItem();
    this.$el.classList.add('pointer-events-none');
    setTimeout(() => {
      this.$el.classList.remove('pointer-events-none');
    }, 1000);
  }

  /**
   * Add item to session storage
   * @returns {void}
   */
  setItem() {
    sessionStorage.setItem('popin_displayed', 'true');
  }

  /**
   * On tab mouse enter
   */
  onTabLabelMouseenter() {
    this.$el.classList.toggle('tabs__open');
  }
}
